import { useEffect } from 'react';

import * as styles from './styles';
import { useAdvertisementContext } from '@context/Advertisement';
import FocusableBackButton from '@components/FocusableBackButton';
import { FocusContext, useFocusable } from '@noriginmedia/norigin-spatial-navigation';

const FullBannerView = () => {
  const { image } = useAdvertisementContext();
  const { focusKey, focusSelf } = useFocusable();

  useEffect(() => {
    focusSelf();
  }, [focusSelf]);

  return (
    <FocusContext.Provider value={focusKey}>
      <div
        css={[
          styles.rootContainer,
          {
            background: `url(${image})`
          }
        ]}
      >
        <div css={styles.backButtonContainer}>
          <FocusableBackButton />
        </div>
      </div>
    </FocusContext.Provider>
  );
};

export default FullBannerView;
